class PrimaryDependency {
  static check = (e) => {
    return new Promise((resolve) => {
    let pid = e.name.substring(1); 
    let sit = e.label;
    let q = {
      pid: pid,
      sit: sit
    };
    //primary_field_html_id
    if(window.pardot && window.pardot.FormDependencyMap) {
      let apd = window.pardot.FormDependencyMap.filter((o) => {
        return o.primary_field_html_id === q.pid;
      },q);

      let pd = apd.filter((o) => {
        return (o.primary_field_html_id === q.pid && 
          o.primary_field_value.trim().toLowerCase() === q.sit.trim().toLowerCase());
      },q);
      //hide these
      apd.forEach((h) => {
        let wo = document.querySelector("#d" + h.secondary_field_html_id);
        if(wo) {
          if(!wo.classList.contains("hidden")) {
            wo.classList.add("hidden");
          }
        }
      }); 
      //show these
      if(pd) {
        pd.forEach((pdh) => {
          let wop = document.querySelector("#d" + pdh.secondary_field_html_id);
          if(wop) {
            if(wop.classList.contains("hidden")) {
              wop.classList.remove("hidden");
            }
          }
        });
      }
    }
    resolve("done")
  });

  }
}

export {PrimaryDependency}
